<template>
  <div class="dropdown">
    <button class="dropbtn">{{ selectedStructure.name }}</button>
    <div class="dropdown-content">
      <ul class="sub-menu">
        <li>
          <a v-for="struct in structures" :key="struct.name" @click="selectStructure(struct)">{{ struct.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "dropdown",
  props: {
    structures: Array,
    selectedStructure: Object,
  },
  data() {
    return {
      showDropDown: true,
    };
  },
  methods: {
    selectStructure: function (structure) {
      this.$emit("struct-selected", structure);
      this.selectedOne = structure;
    },
  },
  watch: {
    selectedStructure: function (newStruct) {
      this.selectedOne = newStruct;
    },
  },
};
</script>
<style scoped>
.dropbtn {
  color: white;
  background-color: rgb(40, 42, 59);
  transition-duration: 0.4s;
  height: 60px;
  width: 180px;
  font-weight: 700;
  font-size: 0.9em;
  border: none;
}

.dropbtn:active {
  content: "";
  border: none;
}

.dropdown {
  position: relative;
  display: inline-block;
  background-color: rgb(37, 39, 48);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-bottom: 1px solid black;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: rgb(32, 34, 43);
  width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 3;
}

.dropdown-content a {
  color: white;
  opacity: 0.9;
  padding: 12px 12px;
  text-decoration: none;
  display: block;
  font-weight: 500;
  font-size: 0.8em;
}

.dropdown-content a:hover {
  background-color: rgba(255, 255, 255, 0.164);
  cursor: pointer;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: rgba(255, 255, 255, 0.164);
}
</style>
